module.exports = __webpack_public_path__ + "img/offers_illustration_one.ac4207ad.svg";